module.exports = import("https://apiimg.iberostar.com/fastbooking/dist/assets/remoteEntry.js?ts=202610140815");